import { render, staticRenderFns } from "./OpdrachtFilter.vue?vue&type=template&id=38a62f5c"
import script from "./OpdrachtFilter.vue?vue&type=script&lang=ts"
export * from "./OpdrachtFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports